
import {
    stores,
    history,
    registerRoutes, registerStores
} from 'mutants-microfx';
import {
  registerViewModel,
  registerDataProvider,
  registerController,
  registerAppFlow,
  AppFlow,
  appManager
} from 'mutants-appfx';
import {
  registerLogoutMiddleWare
} from 'tplus-api';
import {
  registerLoginMiddleWare,
  PosInitData
} from 'tplus-poslogin';

import viewModels from './viewModels';
import {dataProvider,appMenuKey} from './dataProvider';
import RetailOrderController from './controllers/RetailOrderController.js';
import RetailOrderViewController from './viewControllers/RetailOrderViewController.js';
import pageLocalStore from './localStore'
import {MiddleWare} from 'tplus-portaltouch'
import storeRegistry from './stores/index.js'
import { SelfSettlement,SelfSuccess,SelfFailure } from './selfsettle'
import view from './views/View.js'

registerController('RetailOrderController', RetailOrderController, RetailOrderViewController);
registerViewModel('RetailOrderView', view,...viewModels);
registerDataProvider(appMenuKey,dataProvider);
registerAppFlow(appMenuKey,new AppFlow(false,false,true));
registerStores(storeRegistry)

//登陆钩子
registerLogoutMiddleWare('pos_logout',()=>{
  console.log('执行注销后的清理动作');
});
registerLoginMiddleWare('login',()=>{
  //stores.setStore.initSetParams();
  console.log('执行POS登录后的初始化动作');
});

MiddleWare.registerMiddleWare({middlewareName:'onDuty',middleware:()=>{
  console.log('isClearLimitOrderWhenShift',PosInitData('isClearLimitOrderWhenShift'))
  if( PosInitData('isClearLimitOrderWhenShift')=='1' ){
    // pageLocalStore.shift.bind(pageLocalStore)
    pageLocalStore.shift()
  }
}});
registerRoutes([
  {
    path:'/selfSettle',
    component:SelfSettlement
  },{
    path:'/selfSuccess',
    component:SelfSuccess
  },{
    path:'/selfFailure',
    component:SelfFailure
  }

],)

